import { api } from "../services/api";
import { persistEnrichmentReviewCoalesced } from "./enrichmentReviewPersist";

const timersByJob = new Map();
const pendingByJob = new Map();
const DEFAULT_MS = 750;

function patchEnrichmentReview(jobId, body) {
  return api.patchJobEnrichmentReview(jobId, body);
}

/**
 * Debounce PATCH of enrichment review preview to the job record.
 * Sends a slim merge payload (review deltas only); local UI keeps the full preview.
 */
export function scheduleEnrichmentReviewPersist(
  jobId,
  preview,
  auditEvent = null,
  delayMs = DEFAULT_MS
) {
  const jid = String(jobId || "").trim();
  if (!jid || !preview) return;

  pendingByJob.set(jid, { preview, auditEvent });

  const existing = timersByJob.get(jid);
  if (existing) clearTimeout(existing);

  timersByJob.set(
    jid,
    setTimeout(() => {
      timersByJob.delete(jid);
      const pending = pendingByJob.get(jid);
      pendingByJob.delete(jid);
      if (!pending?.preview) return;
      void persistEnrichmentReviewCoalesced(
        jid,
        pending.preview,
        { auditEvent: pending.auditEvent },
        patchEnrichmentReview
      ).catch((err) =>
        console.error("Failed to persist enrichment review", err)
      );
    }, delayMs)
  );
}

/** Cancel debounced timer without writing. */
export function cancelEnrichmentReviewPersist(jobId) {
  const jid = String(jobId || "").trim();
  if (!jid) return;
  const t = timersByJob.get(jid);
  if (t) clearTimeout(t);
  timersByJob.delete(jid);
  pendingByJob.delete(jid);
}

/** Write the latest preview immediately (e.g. after approve/discard or before close). */
export async function persistEnrichmentReviewNow(
  jobId,
  preview,
  auditEvent = null,
  options = {}
) {
  const jid = String(jobId || "").trim();
  if (!jid) return;

  const t = timersByJob.get(jid);
  if (t) clearTimeout(t);
  timersByJob.delete(jid);

  const pending = preview
    ? { preview, auditEvent }
    : pendingByJob.get(jid);
  pendingByJob.delete(jid);

  if (!pending?.preview) return;

  await persistEnrichmentReviewCoalesced(
    jid,
    pending.preview,
    { auditEvent: pending.auditEvent, force: Boolean(options.force) },
    patchEnrichmentReview
  );
}
